import { FieldSchema } from "../../../Schema";

export const documentedMaintenanceDate: FieldSchema = {
  name: "documentedMaintenanceDate",
  grid: {
    displayed: false,
    order: 42,
  },
  data: {
    active: false,
  },
  display: {
    displayed: true,
  },
  // The exclusivity rule with dateOfNextMaintanance is declared on that field, so the
  // error is reported once rather than by both halves of the pair.
  form: {
    label: "Maintenance dates documented elsewhere?",
    displayed: false,
    disabled: true,
  },
};
